import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row geolocation" }

import { computed, inject, reactive } from 'vue';
import {
  YandexMap,
  YandexMapControls,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultMarker,
  YandexMapDefaultSchemeLayer,
  YandexMapZoomControl,
} from 'vue-yandex-maps';

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { GeolocationFieldParams } from 'SharedDir/declarations/fields';
import { resolveService } from 'SharedDir/utils/vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'GeolocationField' },
  __name: 'Geolocation',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {


const props = __props;

const coords = computed(() => (props.params.coords ? [...props.params.coords].reverse() : null));

const center = computed(() => {
  if (!coords.value || coords.value.length !== 2 || !coords.value[0] || !coords.value[1]) {
    return [61.003184, 69.023455].reverse();
  }
  return coords.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(YandexMap), {
      settings: {
        location: {
          center: center.value,
          zoom: 12,
          duration: 1000,
        },
      },
      width: "100%",
      height: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(YandexMapDefaultSchemeLayer)),
        _createVNode(_unref(YandexMapDefaultFeaturesLayer)),
        _createVNode(_unref(YandexMapControls), { settings: { position: 'right' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(YandexMapZoomControl))
          ]),
          _: 1
        }),
        (coords.value)
          ? (_openBlock(), _createBlock(_unref(YandexMapDefaultMarker), {
              key: 0,
              settings: {
          coordinates: coords.value,
        }
            }, null, 8, ["settings"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["settings"])
  ]))
}
}

})